import * as XLSX from "xlsx";

/**
 * Книга Excel из готовой таблицы отчёта — одна на все отчёты.
 *
 * Раньше эта логика была скопирована в семь файлов, и ошибка в ней означала
 * семь разных поведений. Ошибка была такая: SheetJS при разборе HTML сам
 * пытается прочитать текст ячейки как дату, и суммы с разделителями разрядов
 * под это попадали — «12 016 018» превращалось в 43450, серийный номер даты
 * Excel, а деньги из отчёта пропадали. Отсюда `raw`: все ячейки приходят
 * текстом, а числами их делает разбор ниже.
 */
export function createWorkbookFromTable(table, sheetName = "Sheet1") {
  const workbook = XLSX.utils.table_to_book(table, { sheet: sheetName, raw: true });
  const sheet = workbook.Sheets[sheetName];

  Object.keys(sheet)
    .filter(key => key[0] !== "!")
    .forEach(key => {
      const cell = sheet[key];
      // Идентификаторы (ИНН, номер счёта, ID сделки) помечены текстовым
      // форматом: у них нельзя терять ведущие нули, числами их делать нельзя.
      if (cell.z === "@") return;
      if (typeof cell.v !== "string") return;

      const cleaned = cell.v.replace(/\s+/g, "").replace(/,/g, "");
      if (cleaned === "" || isNaN(cleaned)) return;

      cell.v = Number(cleaned);
      cell.t = "n";
      cell.z = "0";
    });

  return workbook;
}

/**
 * Значение ячейки для выгрузки, когда лист собирается не из таблицы, а вручную
 * (отчёт «Счета»).
 *
 * Ноль — это значение, а не пустота: прежнее `value || ""` стирало его, и
 * «оплачено 0» в файле было не отличить от «неизвестно».
 */
export function excelCellValue(value) {
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split("-");
    return `${day}.${month}.${year}`;
  }
  if (value === null || value === undefined) return "";
  return value;
}

/**
 * Атрибуты ячейки-идентификатора для выгрузки через createWorkbookFromTable.
 *
 * Колонка с `exportAsText` (ИНН, номер счёта, ID сделки) попадает в Excel
 * текстом: ведущие нули не теряются, а разбор чисел её не трогает.
 */
export function textCellAttributes(value, column) {
  return column.exportAsText
    ? { "data-t": "s", "data-v": value == null ? "" : String(value), "data-z": "@" }
    : {};
}
